// Google Analytics 4 Configuration for SnapTools
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

// Replace with your actual GA4 Measurement ID
export const GA_MEASUREMENT_ID = 'G-675FP9XN7N'; // Your actual GA4 Measurement ID

// Initialize Google Analytics
export const initGA = () => {
  // Create script tag for gtag
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // Initialize dataLayer and gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  // Configure GA4
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    // Enhanced privacy settings
    anonymize_ip: true,
    cookie_flags: 'SameSite=Strict;Secure',
    // Custom settings for file conversion tracking
    custom_map: {
      custom_parameter_1: 'conversion_type',
      custom_parameter_2: 'file_size',
      custom_parameter_3: 'processing_time'
    }
  });
};

// Track page views
export const trackPageView = (page_title: string, page_location: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'page_view', {
      page_title,
      page_location,
      send_to: GA_MEASUREMENT_ID
    });
  }
};

// Track file conversions
export const trackConversion = (conversionType: string, fileSize: number, processingTime: number) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'file_conversion', {
      event_category: 'conversion',
      event_label: conversionType,
      custom_parameter_1: conversionType,
      custom_parameter_2: fileSize,
      custom_parameter_3: processingTime,
      value: 1
    });
  }
};

// Track downloads
export const trackDownload = (fileName: string, fileType: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'file_download', {
      event_category: 'download',
      event_label: `${fileType}_download`,
      file_name: fileName,
      file_type: fileType
    });
  }
};

// Track user engagement
export const trackEngagement = (action: string, page: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', action, {
      event_category: 'engagement',
      event_label: page,
      page: page
    });
  }
};

// Track errors
export const trackError = (errorType: string, errorMessage: string, page: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'exception', {
      description: errorMessage,
      fatal: false,
      error_type: errorType,
      page: page
    });
  }
};
